import Vue from 'vue';
import Router from 'vue-router';
import AnswerScreen from '@/components/AnswerScreen';
import Home from '@/components/Home';
import Admin from '@/components/Admin';
import url from '../../config/root-url';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path      : `/`,
      name      : `Root`,
      redirect  : `/choose/manager`,
    },
    {
      path      : `/choose/:item`,
      name      : `Home`,
      component : Home,
      props     : true,
    },
    {
      path      : `/answer`,
      name      : `Answer`,
      component : AnswerScreen,
    },
    {
      path      : `/admin`,
      name      : `Admin`,
      component : Admin,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js